import type { AnyProperty } from '@/utilities.types';

type TrackInformation = string | AnyProperty;
type TrackFunction = (
  category: string,
  action: string,
  information?: TrackInformation,
  dateRange?: { displayRange: any; investigateRange: any },
) => void;

let trackFunction: TrackFunction = () => undefined;

export function registerTrackFunction(fn: TrackFunction) {
  trackFunction = fn;
}

export function doTrack(
  category: string,
  action: string,
  information?: TrackInformation,
  dateRange?: { displayRange: any; investigateRange: any },
) {
  return trackFunction(category, action, information, dateRange);
}
